var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"product-category-link",attrs:{"to":{
    name: _vm.route,
    params: { productCategoryId: _vm.productCategory.id },
  }}},[_c('div',{staticClass:"product-category-card card"},[_c('div',{staticClass:"card-body"},[_c('div',{staticClass:"card-title card-name"},[_vm._v(_vm._s(_vm.productCategory.name))]),_c('br')])])])
}
var staticRenderFns = []

export { render, staticRenderFns }